export default "__VITE_ASSET__7RhYOBgW__"